import { faAdd } from "@fortawesome/free-solid-svg-icons";
import React, { useState } from "react";
import { Button, Card, Col, Row, Stack } from "react-bootstrap";
import { postJob } from "../../../services/httpClient";
import Input from "../../ui/Input";
import JobCard from "./JobCard";
import { unsavedChanges } from "../../../App";
import IconEmbeddedButton from "../../ui/IconEmbeddedButton";

interface JobsState {
  jobs: any;
  getJobs: any;
  setOrgToSave: any;
  setErrMessage: any;
  setShowToast: any;
  setToastText: any;
  setToastBody: any;
}

const Jobs = ({ jobs, getJobs, setOrgToSave, setErrMessage, setShowToast, setToastText, setToastBody }: JobsState) => {
  const [newDept, setNewDept] = useState<string>("");
  const [newJob, setNewJob] = useState<string>("");
  const [newPositionTotal, setNewPositionTotal] = useState<number>();
  const [showAddJob, setShowAddJob] = useState(false);
  const [disableDepartment, setDisableDepartment] = useState(false);

  const onClickAddJob = (dept?: string) => {
    setShowAddJob(true);
    if (dept) {
      setDisableDepartment(true);
      setNewDept(dept);
    }
  };

  const updateNewDept = (e: any) => {
    setNewDept(e.target.value);
    unsavedChanges.value = true;
    setOrgToSave(true);
  };

  const updateNewJob = (e: any) => {
    setNewJob(e.target.value);
    unsavedChanges.value = true;
    setOrgToSave(true);
  };

  const updateNewPositionTotal = (e: any) => {
    setNewPositionTotal(e.target.value);
    unsavedChanges.value = true;
    setOrgToSave(true);
  };

  const onClickSaveJob = (isDone: boolean = false) => {
    const _job = {
      name: newJob,
      department: newDept,
      positions_total: newPositionTotal,
    };

    setErrMessage("");

    postJob(_job)
      .then((res: any) => {
        setShowToast(true);
        setToastText("Job Created");
        setToastBody(newJob);
        setNewJob("");
        setNewPositionTotal(undefined);
        unsavedChanges.value = false;
        setOrgToSave(false);
        if (isDone) {
          setNewDept("");
          setShowAddJob(false);
          setDisableDepartment(false);
        }
        getJobs(true);
      })
      .catch((err: any) => {
        setErrMessage(err?.response?.data?.msg);
        window.scrollTo({
          top: 0,
          behavior: "auto",
        });
      });
  };

  const onClickCancelAddJob = () => {
    setErrMessage("");
    setShowAddJob(false);
    setDisableDepartment(false);
    setNewDept("");
    setNewJob("");
    setNewPositionTotal(undefined);
    unsavedChanges.value = false;
    setOrgToSave(false);
  };

  return (
    <>
      {jobs.length === 0 ? (
        <p className="mt-2">No Job Records</p>
      ) : (
        <Row>
          <Col xs={12}>
            {jobs?.map((dept: any, index: number) => (
              <Card key={index} className="mt-3 pt-2 px-2 bg-light">
                <Row>
                  <Col className="d-flex justify-content-between align-items-center">
                    <div
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        width: "100%",
                      }}
                    >
                      <h6 className="ms-1 mb-3">{dept[0].department}</h6>
                    </div>
                    <div className="me-1 mb-3">
                      <IconEmbeddedButton
                        onClickButton={() => onClickAddJob(dept[0].department)}
                        tooltipText="Add"
                        icon={faAdd}
                        disabled={showAddJob}
                      />
                    </div>
                  </Col>
                </Row>
                <Card.Body className="p-0">
                  {dept?.map((j: any, index: number) => (
                    <JobCard
                      item={j}
                      getItems={getJobs}
                      setOrgToSave={setOrgToSave}
                      setErrMessage={setErrMessage}
                      setShowToast={setShowToast}
                      setToastText={setToastText}
                      setToastBody={setToastBody}
                    />
                  ))}
                </Card.Body>
              </Card>
            ))}
          </Col>
        </Row>
      )}
      {showAddJob !== true && (
        <Row className="mt-3">
          <Col xs={6} lg={4}>
            <Button className="app-tertiary-color button" onClick={(e) => onClickAddJob("")} disabled={showAddJob}>
              Add Department and Job
            </Button>
          </Col>
        </Row>
      )}
      {showAddJob === true && (
        <>
          <Row className="align-items-center my-3">
            <Col xs={3}>
              <Input
                label="Department"
                type="text"
                value={newDept}
                disabled={disableDepartment}
                onUpdate={(e: any) => updateNewDept(e)}
                hasFocus={disableDepartment ? false : true}
              />
            </Col>
            <Col xs={6}>
              <Input
                label="Job"
                type="text"
                value={newJob}
                onUpdate={(e: any) => updateNewJob(e)}
                hasFocus={disableDepartment ? true : false}
                required={true}
              />
            </Col>
            <Col xs={3}>
              <Input
                label="Positions #"
                type="number"
                value={newPositionTotal}
                onUpdate={(e: any) => updateNewPositionTotal(e)}
                required={true}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12} lg={8}>
              <Stack direction="horizontal" gap={3}>
                <Button className="app-secondary-color button" onClick={() => onClickSaveJob(false)}>
                  Save and Add Another
                </Button>
                <div className="vr" />
                <Button className="app-secondary-color button" onClick={() => onClickSaveJob(true)}>
                  Save and Done
                </Button>
                <div className="vr" />
                <Button className="app-primary-color button" onClick={() => onClickCancelAddJob()}>
                  Done
                </Button>
              </Stack>
            </Col>
          </Row>
        </>
      )}
      <Row className="mb-5"></Row>
    </>
  );
};

export default Jobs;
